module.exports = __webpack_public_path__ + "img/logo3.1348170c.png";